import { ScheduleItem } from '@/common/api/params/mediaAnalysisAutomation'
import { createModalContext, useModalState } from '@/common/app/modal'
import { ChildProps } from '@/common/util/props'

import MediaAnalysisAutomationSettingsModal from '@/components/container/modal/mediaAnalysisAutomation/MediaAnalysisAutomationSettingsModal'

interface MediaAnalysisAutomationSettingsModalState {
  siteId: number
  item: ScheduleItem | null
  onSaved(): void
  forEnabling?: boolean
}

const defaultValue: MediaAnalysisAutomationSettingsModalState = {
  siteId: 0,
  item: null,
  onSaved: () => undefined
}

export const MediaAnalysisAutomationSettingsModalContext =
  createModalContext<MediaAnalysisAutomationSettingsModalState>(defaultValue)

const MediaAnalysisAutomationSettingsModalProvider = ({ children }: ChildProps) => {
  const state = useModalState<MediaAnalysisAutomationSettingsModalState>(defaultValue)
  return (
    <MediaAnalysisAutomationSettingsModalContext.Provider value={state}>
      {children}
      <MediaAnalysisAutomationSettingsModal />
    </MediaAnalysisAutomationSettingsModalContext.Provider>
  )
}

export default MediaAnalysisAutomationSettingsModalProvider
